<div class="widget" style="position:relative; min-height: 236px; font-size: 14px; flex: none; margin: 0; width: 100%">
  <div class="header flex v-center">
    <div class="title">Video Event Stats Summary</div>
  </div>
  <div class="loader absolute" *ngIf="isLoading">
    <svg class="circular" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
    </svg>
  </div>
  <div class="flex" style="overflow-x: overlay; justify-content: center" *ngIf="!isLoading && !amIStandardPlan">
    <div class="bar-chart-contents-box" style="flex: 2">
      <div class="bar-chart-contents-box-title">Cloud AI Usage</div>
      <div class="flex between mt-16">
        <div class="flex v-center" style="gap: 4px">
          <div [class.gray-text]="excessAmount">{{reservedEvents.freeEvent}} Allocated Events</div>
          <div class="alert" *ngIf="excessAmount">(Exceeded by {{excessAmount}} events)</div>
          <dev *ngIf="availableAmount">({{availableAmount}} events still Available)</dev>
        </div>
        <div class="flex v-center" style="gap: 4px">
          <div class="circle" [ngClass]="comptedUsageChartColor()"></div>
          <div>{{reservedEvents.totalUsedEvents}}</div>
          <div>|</div>
          <div>{{reservedEvents.totalUsedEventsRatio}}%</div>
        </div>
      </div>
      <div class="dashboard-widget-contents-box-total-box">
        <div class="dashboard-widget-contents-box-total-box-used" [ngClass]="comptedUsageChartColor()" [style.width]="reservedEvents.totalUsedEventsRatio+'%'"></div>
      </div>
      <div class="flex between" style="margin-top: 6px">
        <div>0</div>
        <div [class.gray-text]="excessAmount">{{reservedEvents.freeEvent}} events</div>
      </div>
      <div class="excess-alert" [class.alert]="excessAmount" *ngIf="!isSubDealer && isHasViewPricePermission">
        <comp-icon *ngIf="excessAmount" [icon]="'warning'" [size]="16" [color]="'orange'"></comp-icon>*Exceeding this limit incurs {{usersService.me().currency_symbol}}{{reservedEvents.eventCostPerEventBoundary}} / {{reservedEvents.eventEventBoundary}} events
      </div>
      <div class="excess-alert">*This feature is billed regardless of the activation period.</div>
    </div>
    <div class="bar-chart-contents-box" style="flex: 1" *ngIf="isShowTrueFalseAlarmChart()">
      <div class="bar-chart-contents-box-title">Total Cloud AI Events - True alarm | False alarm</div>
      <div class="flex" style="margin-top: 16px">
        <div class="bar-chart-contents-box-count primary">{{statisticsData.trueSignals}}</div>
        <div class="bar-chart-contents-box-count divider">|</div>
        <div class="bar-chart-contents-box-count danger">{{statisticsData.falseSignals}}</div>
      </div>
      <div class="bar-chart-contents-box-sub-info">
         Total AI request: {{statisticsData.totalVideoEvents}} events</div>
      <div class="bar-chart-contents-box-total-box">
        <div class="bar-chart-contents-box-total-box-true" [style.width]="statisticsData.trueSignalRatio+'%'"></div>
        <div class="bar-chart-contents-box-total-box-false" [style.width]="statisticsData.falseSignalRatio+'%'"></div>
      </div>
      <div class="flex" style="justify-content: space-between;">
        <div class="txt-primary" style="font-size:14px">True {{statisticsData.trueSignalRatio}}%</div>
        <div class="txt-danger" style="font-size:14px">False {{statisticsData.falseSignalRatio}}%</div>
      </div>
    </div>
  </div>
  <div class="widget-body" *ngIf="!isLoading && amIStandardPlan">
    <div class="item-row" style="overflow-x: overlay; justify-content: center">
      <comp-icon class="no-cloud-ai-icon" [icon]="'person_play'" [size]="42" [color]="'#87909f'"></comp-icon>
      <div class="flex-column justify-center" style="margin-left: 16px;">
        <div class="no-cloud-ai-title">Unlock More with an Upgrade! 🚀</div>
        <div class="no-cloud-ai-desc">
          Cloud AI features are available exclusively with our Professional or Premium plans.<br/>
          Upgrade for enhanced video event analysis and filtering, reducing operational time and costs. Consider upgrading for more benefits.
        </div>
        <div>
          <div class="btn-area">
            <div class="button button-white" (click)="onClickGoToDealerPlan()">
              <div class="btn-inner" [class.disabled]="isLoading">Go to upgrade plan</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>